import React, { useState, useEffect } from 'react';
import SmartFilter from '../../../../components/common/smartFilter';
import '../../compliance/style/Compliance.css';
import Pagination from '../../../../components/common/pagination';
import { debounce } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getActionNamesByPolicyName } from '../../../../utils/helper/Helper';
import EmptyScreen from '../../../../components/common/emptyScreen';
import '../../compliance/style/ComplianceLayout.css';
import { ALL_ROUTES } from '../../../../routes/dashboard/overview/AllPathNames';
import ComplianceTabLink from './ComplianceTabLink';
import RootState from '../../../../../redux/types';
import { RavenButton, RavenModal, toast } from '@ravenpay/raven-bank-ui';
import { icons } from '../../../../../assets/icons';
import RequestTabLink from './RequestTabLink';
import DashboardLayout from '../../../../../layout/dashboard/dashboardLayout';
import PageLayout from '../../../../../layout/dashboard/tableLayout';
import DeviceRequest from './DeviceRequest';

interface MyComponentProps {
	children?: React.ReactNode;
	btnContent?: React.ReactNode;
	tabLink?: React.ReactNode;
	activeTabIndex?: string;
	setActiveTabIndex?: (param?: any) => void;
}

const RequestLayout = ({
	children,
	btnContent,
	tabLink,
	activeTabIndex,
	setActiveTabIndex,
}: MyComponentProps) => {
	// const { profile } = useSelector((state: RootState) => state.settings);
	// const [activeTab, setActiveTab] = useState<string>('BVN Verification');
	const location = useLocation();
	const navigate = useNavigate();

	// Define tab routes and content

  const [createModal, setCreateModal] = useState<boolean>(false);
	const { profile } = useSelector((state: RootState) => state.settings);
	// if (
	// 	!getActionNamesByPolicyName(
	// 		profile?.rolePolicies?.policies,
	// 		'compliance'
	// 	)?.includes('view_compliance')
	// ) {
	// 	return (
	// 		<DashboardLayout>
	// 			<>
	// 				<EmptyScreen
	// 					loading={Object?.keys(profile)?.length < 1 ? true : false}
	// 					title="Permission Denied"
	// 					subTitle="You have no permission to access this page, Please contact admin or support."
	// 				></EmptyScreen>
	// 			</>
	// 		</DashboardLayout>
	// 	);
	// }

	// Render component
	return (
		<>
			<DashboardLayout>
				<PageLayout
					pageSubtitle="All BankBox request made on the platform"
					pageTitle="Request"
					topRightContent={
						<>
							<RavenButton
								color="deep-green-light"
								className="reqs raven-btn-restlye-bankbox"
								onClick={() => setCreateModal(true)}
								
							>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: '1rem',
									}}
									className="button__wrap"
								>
									<span>Request a Device</span>
									<figure>{icons.plus_circle_white}</figure>
								</div>
							</RavenButton>
						</>
					}
				>
					<div className="com-layout-index-wrap-box">
						{/* Tabs Navigation */}
						<div className="children-route-wrapper-box white-faded-white-bg com-layout">
							{/* tablink start */}
							{/* <RequestTabLink
								activeTabIndex={activeTabIndex}
								setActiveTabIndex={setActiveTabIndex}
							/> */}
							{/* tab link end */}

							{/* Render Active Tab's Content */}
							<div className="children-wrap-box">{children}</div>
						</div>
					</div>
				</PageLayout>
			</DashboardLayout>

			<RavenModal
				visble={createModal}
				onClose={() => setCreateModal(false)}
				className={'bankbox-create-modal bankbox-create-setup-modal'}
				onBtnClick={function (e?: any): void {
					throw new Error('Function not implemented.');
				}}
			>
				<DeviceRequest
					onComplete={() => {
						setCreateModal(false),
							toast.success('BankBox merchant created successfully');
					}}
				/>
			</RavenModal>
		</>
	);
  
};

export default RequestLayout;
